import { FC } from 'react';

import { EmployeeInfo } from 'src/components/EmployeeInfo/EmployeeInfo';
import { Section } from 'src/components/Section/Section';
import { SpaceInfoComponent } from 'src/components/SpaceInfo/SpaceInfo';

export interface ReservedBySpaceProps {
  spaceAdministrator?: string;
  spaceId: number;
}

export const ReservedBySpaceInfo: FC<ReservedBySpaceProps> = ({
  spaceId,
  spaceAdministrator,
}) => {
  return (
    <>
      {spaceAdministrator && (
        <Section title='Ответственный по блоку' testId='responsibleSection'>
          <EmployeeInfo
            employeeNumber={spaceAdministrator}
            testId='responsible'
          />
        </Section>
      )}
      <Section title='Закреплено за блоком' testId='responsibleSection'>
        <SpaceInfoComponent spaceId={spaceId} />
      </Section>
    </>
  );
};
